﻿import React from 'react';
import Lottie from 'lottie-react';

import houseAnimData from '../../../../AnimationFiles/house.json';

const HomeAnimation = () => {

    const interactivity = {
        mode: "scroll",
        actions: [
            {
                visibility: [0, 1],
                type: "seek",
                frames: [0, 50],
            },
            {
                visibility: [0, 1],
                type: "play",
                frames: [50, 119],
            },
        ],
    };

    return (
        <Lottie
            className="car-insurance-campaign__home__animation"
            autoplay={false}
            loop={true}
            animationData={houseAnimData}
            interactivity={interactivity}
        />
     )
 }                

export default HomeAnimation;